export default "__VITE_ASSET__a5329da6__"